export const environment = {
  development: false,
  azureAd: {
    clientId: '72bd7fd1-6e64-4855-a820-af7c4dcfbcfa',
    authority: 'https://login.microsoftonline.com/972847c0-3e8e-430c-b42d-c8ca486e17d0',
    GroupId: {
      User: 'dc60fe13-cb3f-473f-bdc2-7e93b4105db4',
      Admin: 'b895463a-153a-4bd2-beba-9efea14f7814',
      Coach: '2c560a28-716d-44e6-adea-d904a1c768f1',
    },
    apiConfig: {
      scopes: ['api://engage-acc.abc-groep.be/API.Use', 'openid', 'profile', 'user.read'],
      uri: 'https://ca-abcgroep-engage-acc.ambitiouswater-73fcc48c.swedencentral.azurecontainerapps.io',
    },
  },
};
